<template>
  <div
    :class="className"
    class="xy-pagelet-container"
  >
    <slot v-if="$slots.default" />
    <div
      v-else-if="showPlaceholder"
      class="xy-pagelet-container-placeholder"
    >
      <span>{{ $t("k_bca7b6c3") }}</span>
    </div>
  </div>
</template>
<script>
import { computed, inject } from '@vue/composition-api';
import { usePageletEvent } from '@composables/usePageletEvent';

export default {
  name: 'XyPageletContainer',
  props: {
    className: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const w = inject('w', null);
    const showPlaceholder = computed(() => w?.mode === 'editor');

    usePageletEvent({ emit });

    return { showPlaceholder };
  },
};
</script>

<style lang="scss">
.xy-pagelet-container {
  position: relative;
  min-height: max(100%, 1em);
  .xy-pagelet-container-placeholder {
    padding: 6px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    border: 1px dashed;
  }
}
</style>
